export const moveTo = "I_a";
export default {moveTo};